import { DragIndicator } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

interface OrganizeChapterRowProps {
  title: string
  fontFamily?: string
  /** Spread these onto the root to make the header a drag handle. */
  dragHandleProps?: Record<string, unknown>
}

export default function OrganizeChapterRow({ title, fontFamily, dragHandleProps }: OrganizeChapterRowProps) {
  const draggable = Boolean(dragHandleProps)

  return (
    <Box
      {...dragHandleProps}
      sx={{
        px: 1,
        py: 0.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: draggable ? 'grab' : 'default',
        // 'manipulation' keeps the dialog scrollable on mobile — the
        // TouchSensor's long-press delay distinguishes scroll from drag.
        touchAction: draggable ? 'manipulation' : 'auto',
        borderRadius: 1,
        transition: 'background-color 0.15s ease',
        bgcolor: 'rgba(255,255,255,0.04)',
        '&:hover': {
          bgcolor: 'rgba(255,255,255,0.07)',
        },
        '&:active': {
          cursor: draggable ? 'grabbing' : 'default',
        },
        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: 'primary.main',
          outlineOffset: -2,
        },
      }}
    >
      {draggable && <DragIndicator sx={{ fontSize: '1rem', color: 'text.disabled' }} />}
      <Typography
        sx={{
          flex: 1,
          fontFamily: fontFamily || 'SBL Hebrew',
          fontWeight: 600,
          fontSize: '0.85rem',
          color: 'text.secondary',
        }}
      >
        {title || 'Untitled Chapter'}
      </Typography>
    </Box>
  )
}
